import corporateRequest from 'utils/corporateRequest'
import ErrorMessage from 'utils/ErrorMessage'
import instituteRequest from 'utils/instRequest'
import studentRequest from 'utils/studentRequest'
import {
  capitalizeFirstLetter,
  ctcAnalysisColors,
  ctcAnalysisGraphColors,
  ctcCategoryColors,
  formatRange,
  formatStudentCount,
  mapping,
  ruleEngineColors,
  ruleEngineGraphColors,
} from './Components/CommonFunction'
export const SET_FILTERED_DASHBOARD_DETAILS =
  'institute/SET_FILTERED_DASHBOARD_DETAILS'
export const SET_DASHBOARD_DETAILS = 'institute/SET_DASHBOARD_DETAILS'
export const SET_JOB_PROFILE_STATUS = 'corporate/SET_JOB_PROFILE_STATUS'
export const SET_CTC_CATEGORY = 'corporate/SET_CTC_CATEGORY_ANALYSIS'
export const SET_CTC_ANALYSIS = 'corporate/SET_CTC_ANALYSIS'
export const SET_ACTIVE_JOB_ROLES = 'corporate/SET_ACTIVE_JOB_ROLES'
export const SET_STUDENT_PLACEMENT = 'corporate/SET_STUDENT_PLACEMENT'
export const SET_COMPARE_JOB_PROFILE_STATUS =
  'corporate/SET_COMPARE_JOB_PROFILE_STATUS'
export const SET_COMPARE_CTC_ANALYSIS = 'corporate/SET_COMPARE_CTC_ANALYSIS'
export const SET_COMPARE_CTC_CATEGORY = 'corporate/SET_COMPARE_CTC_CATEGORY'
export const SET_COMPARE_STUDENT_PLACEMENT =
  'corporate/SET_COMPARE_STUDENT_PLACEMENT'
export const setFilteredDashboardDetails = data => {
  return {
    type: SET_FILTERED_DASHBOARD_DETAILS,
    data,
  }
}
export const setDashboardDetails = data => {
  return {
    type: SET_DASHBOARD_DETAILS,
    data,
  }
}
export const setJobProfileStatus = data => {
  return {
    type: SET_JOB_PROFILE_STATUS,
    data,
  }
}

export const setCompareJobProfileStatus = data => {
  return {
    type: SET_COMPARE_JOB_PROFILE_STATUS,
    data,
  }
}

export const setCTCCategory = data => {
  return {
    type: SET_CTC_CATEGORY,
    data,
  }
}

export const setCompareCTCCategory = data => {
  return {
    type: SET_COMPARE_CTC_CATEGORY,
    data,
  }
}

export const setCTCAnalysis = data => {
  return {
    type: SET_CTC_ANALYSIS,
    data,
  }
}

export const setCompareCTCAnalysis = data => {
  return {
    type: SET_COMPARE_CTC_ANALYSIS,
    data,
  }
}

export const setActiveJobRoles = data => {
  return {
    type: SET_ACTIVE_JOB_ROLES,
    data,
  }
}

export const setStudentPlacement = data => {
  return {
    type: SET_STUDENT_PLACEMENT,
    data,
  }
}

export const setCompareStudentPlacement = data => {
  return {
    type: SET_COMPARE_STUDENT_PLACEMENT,
    data,
  }
}

export const getTpoPrimaryCardData =
  (instituteCampusId, payLoad, filterStatus) => async dispatch => {
    try {
      const res = await corporateRequest.post(
        `corporate/institute/tpo/${instituteCampusId}`,
        payLoad
      )
      if (res?.data?.message === 'Success') {
        if (filterStatus) {
          dispatch(setFilteredDashboardDetails(res?.data?.data || {}))
        } else {
          dispatch(setDashboardDetails(res?.data?.data || {}))
        }
        return res?.data?.data
      } else {
        throw new Error('Data not available')
      }
    } catch (error) {
      ErrorMessage('Error fetching TPO primary card data.')
      return error
    }
  }

export const getSpecializationList = (campusId, payload) => async () => {
  try {
    const response = await instituteRequest.post(
      `institutes/${campusId}/specialisations`,
      payload
    )
    const data = response?.data?.data || []
    return data
  } catch (err) {
    ErrorMessage('Error fetching roles, Try again .')
  }
}

export const getYear = instituteCampusId => async () => {
  try {
    const result = await studentRequest.get(
      `/students/institutes/${instituteCampusId}/yearOfPassing`
    )
    return result?.data?.data
  } catch (error) {
    ErrorMessage(error?.message)
  }
}

export const getInstituteDetailsFromCampusId =
  () => async (dispatch, getState) => {
    try {
      const state = getState()
      const instituteCampusId = state?.auth?.instituteCampusId

      const result = await instituteRequest.get(
        `/institutes/${instituteCampusId}`
      )

      return result?.data?.data
    } catch (error) {
      ErrorMessage(error?.message)
    }
  }

export const getJobProfileStatus =
  (instituteCampusId, payload, compare) => async dispatch => {
    try {
      const result = await corporateRequest.post(
        `/corporate/institute/tpo/jobProfileStatus/${instituteCampusId}`,
        payload
      )
      if (result?.data?.data) {
        const internship = payload.jobCategory === 'INTERNSHIP'
        const apprenticeship = payload.jobCategory === 'APPRENTICESHIP'
        const gigs = payload.jobCategory === 'GIGS'
        let text = apprenticeship
          ? 'Apprenticeship'
          : internship
          ? 'Internship'
          : gigs
          ? 'Gig'
          : 'Role'
        const mappedData = Object.entries(result?.data?.data)
          .filter(([key]) => key.startsWith('percentage')) // Filter percentage keys
          .map(([key, value]) => {
            const baseKey = key.replace('percentage', '') // Remove 'percentage' from key
            const camelCaseKey =
              baseKey.charAt(0).toLowerCase() + baseKey.slice(1) // Convert to match count keys

            return {
              label: mapping(camelCaseKey, text)?.label, // Get the correct label from mapping
              value,
              [key]: value, // Keep the original percentage key
              roleCount: result?.data?.data[camelCaseKey], // Get the corresponding count value
              background: mapping(camelCaseKey, text)?.bg,
              rgb: mapping(camelCaseKey, text)?.rgb,
              percentageValue: value + '%',
            }
          })

        const statusData = mappedData?.every(
          item => parseFloat(item?.value) === 0
        )
          ? []
          : mappedData

        if (compare) {
          dispatch(setCompareJobProfileStatus(statusData))
        } else {
          dispatch(setJobProfileStatus(statusData))
        }
      }
      return result
    } catch (err) {
      ErrorMessage(err?.message)
      dispatch(setJobProfileStatus([]))
      return err
    }
  }

export const getCTCAnalysis =
  (instituteCampusId, payload, compare) => async dispatch => {
    try {
      const result = await corporateRequest.post(
        `/corporate/institute/tpo/ctcAnalysis/${instituteCampusId}`,
        payload
      )
      let packagePeriod = payload.jobCategory === 'PLACEMENT' ? 'PA' : 'PM'
      if (result?.data?.data) {
        const data = result?.data?.data?.range
        // If not isCompensation, keep all items
        const isCompensation = data?.every(item => item?.isCompensation)
        const filteredData = !isCompensation
          ? data?.filter(item => item?.percentage > 0)
          : data

        const ranges = filteredData?.map((item, index) => {
          return {
            ...item,
            label: item?.isCompensation
              ? item?.name
              : formatRange(item?.start_range, item?.end_range, packagePeriod),
            value: item.percentage,
            percentageValue: item.percentage + '%',
            absoluteNumbers: formatStudentCount(
              item?.count,
              item?.male,
              item?.female,
              item?.other
            ),
            backgroundColor: item?.isCompensation
              ? ruleEngineColors[index]
              : ctcAnalysisColors[index],
            background: item?.isCompensation
              ? ruleEngineGraphColors[index]
              : ctcAnalysisGraphColors[index],
          }
        })

        const stats = result?.data?.data?.stats?.map((item, index) => {
          return {
            ...item,
            label: capitalizeFirstLetter(item?.name),
            absoluteNumbers: formatStudentCount(
              item?.total,
              item?.male,
              item?.female,
              item?.other
            ),
            count: item?.count || 0,
            disable: item?.name === 'median' || item?.name === 'average', // Simplified
            backgroundColor: ctcCategoryColors[index],
            value: `${item?.value} ${packagePeriod}`,
          }
        })
        if (compare) {
          dispatch(
            setCompareCTCAnalysis(
              ranges?.filter(item => item?.percentage > 0) || []
            )
          )
          dispatch(setCompareCTCCategory(stats || []))
        } else {
          dispatch(
            setCTCAnalysis(ranges?.filter(item => item?.percentage > 0) || [])
          )
          dispatch(setCTCCategory(stats || []))
        }
      }
      return result
    } catch (err) {
      ErrorMessage(err?.message)
      dispatch(setCTCAnalysis([]))
      return err
    }
  }

export const getActiveJobRoles =
  (instituteCampusId, payload) => async dispatch => {
    try {
      const result = await corporateRequest.post(
        `/corporate/institute/tpo/activeJobRoles/${instituteCampusId}`,
        payload
      )
      if (result?.data?.data) {
        dispatch(setActiveJobRoles(result?.data?.data || []))
      }
      return result
    } catch (err) {
      ErrorMessage(err?.message)
      dispatch(setActiveJobRoles([]))
      return err
    }
  }

export const getStudentPlacement =
  (instituteCampusId, payload, compare) => async dispatch => {
    try {
      const result = await corporateRequest.post(
        `/corporate/institute/tpo/studentPlacement/${instituteCampusId}`,
        payload
      )
      const placement = payload.jobCategory === 'PLACEMENT'
      if (result?.data?.data) {
        const data = result?.data?.data
        let list = data?.list?.map(item => {
          let label = [item?.degree, item?.stream, item?.specialisation]
            .filter(Boolean)
            .join(' - ')
          label = label == '' ? item?.domain : label
          const formattedLabel =
            label.length > 15 ? label.slice(0, 12) + '...' : label

          return {
            label: formattedLabel,
            fullLabel: label,
            data: [
              {
                label: 'Total',
                total: item?.totalStudents || '0',
                backgroundColor: '#FFFFFF',
                borderColor: '#8A8A8A',
              },
              {
                label: placement ? 'Placed' : 'Selected',
                total: item?.placedStudents || '0',
                male: item?.placedMaleStudents,
                female: item?.placedFemaleStudents,
                others: item?.placedOtherStudents,
                backgroundColor: '#0FB680',
              },
              {
                label: placement ? 'Un-Placed' : 'Un-Selected',
                total: item?.unplacedStudents || '0',
                male: item?.unplacedMaleStudents,
                female: item?.unplacedFemaleStudents,
                others: item?.unplacedOtherStudents,
                backgroundColor: '#F54B56',
              },
              {
                label: 'Opt out',
                total: item?.optedOutStudents || '0',
                male: item?.optedOutMaleStudents,
                female: item?.optedOutFemaleStudents,
                others: item?.optedOutOtherStudents,
                backgroundColor: '#6B7280',
              },
            ],

            ...item,
          }
        })
        const placedMaleStudents = list?.reduce((acc, currentValue) => {
          return acc + (Number(currentValue?.placedMaleStudents) || 0)
        }, 0)

        const unplacedMaleStudents = list?.reduce((acc, currentValue) => {
          return acc + (Number(currentValue?.unplacedMaleStudents) || 0)
        }, 0)

        const higherEducationMaleStudents = list?.reduce(
          (acc, currentValue) => {
            return (
              acc + (Number(currentValue?.higherEducationMaleStudents) || 0)
            )
          },
          0
        )
        const higherEducationFemaleStudents = list?.reduce(
          (acc, currentValue) => {
            return (
              acc + (Number(currentValue?.higherEducationFemaleStudents) || 0)
            )
          },
          0
        )
        const higherEducationOtherStudents = list?.reduce(
          (acc, currentValue) => {
            return (
              acc + (Number(currentValue?.higherEducationOtherStudents) || 0)
            )
          },
          0
        )
        const entrepreneurMaleStudents = list?.reduce((acc, currentValue) => {
          return acc + (Number(currentValue?.entrepreneurMaleStudents) || 0)
        }, 0)
        const entrepreneurFeMaleStudents = list?.reduce((acc, currentValue) => {
          return acc + (Number(currentValue?.entrepreneurFeMaleStudents) || 0)
        }, 0)
        const entrepreneurOthersStudents = list?.reduce((acc, currentValue) => {
          return acc + (Number(currentValue?.entrepreneurOthersStudents) || 0)
        }, 0)
        const familyMaleStudents = list?.reduce((acc, currentValue) => {
          return acc + (Number(currentValue?.familyMaleStudents) || 0)
        }, 0)
        const familyFemaleStudents = list?.reduce((acc, currentValue) => {
          return acc + (Number(currentValue?.familyFemaleStudents) || 0)
        }, 0)
        const familyOthersStudents = list?.reduce((acc, currentValue) => {
          return acc + (Number(currentValue?.familyOthersStudents) || 0)
        }, 0)
        const othersMaleStudents = list?.reduce((acc, currentValue) => {
          return acc + (Number(currentValue?.othersMaleStudents) || 0)
        }, 0)
        const othersFemaleStudents = list?.reduce((acc, currentValue) => {
          return acc + (Number(currentValue?.othersFemaleStudents) || 0)
        }, 0)
        const othersOtherStudents = list?.reduce((acc, currentValue) => {
          return acc + (Number(currentValue?.othersOtherStudents) || 0)
        }, 0)
        const optedOutMaleStudents = list?.reduce((acc, currentValue) => {
          return acc + (Number(currentValue?.optedOutMaleStudents) || 0)
        }, 0)

        const placedFemaleStudents = list?.reduce((acc, currentValue) => {
          return acc + (Number(currentValue?.placedFemaleStudents) || 0)
        }, 0)

        const unplacedFemaleStudents = list?.reduce((acc, currentValue) => {
          return acc + (Number(currentValue?.unplacedFemaleStudents) || 0)
        }, 0)

        const optedOutFemaleStudents = list?.reduce((acc, currentValue) => {
          return acc + (Number(currentValue?.optedOutFemaleStudents) || 0)
        }, 0)

        const placedOtherStudents = list?.reduce((acc, currentValue) => {
          return acc + (Number(currentValue?.placedOtherStudents) || 0)
        }, 0)

        const unplacedOtherStudents = list?.reduce((acc, currentValue) => {
          return acc + (Number(currentValue?.unplacedOtherStudents) || 0)
        }, 0)

        const optedOutOtherStudents = list?.reduce((acc, currentValue) => {
          return acc + (Number(currentValue?.optedOutOtherStudents) || 0)
        }, 0)

        const totalPlacedStudents =
          placedFemaleStudents + placedMaleStudents + placedOtherStudents
        const totalUnPlacedStudents =
          unplacedFemaleStudents + unplacedMaleStudents + unplacedOtherStudents
        const totalOptedOutStudents =
          optedOutFemaleStudents + optedOutMaleStudents + optedOutOtherStudents

        const totalFamilyReasonOptOutStudents =
          familyMaleStudents + familyFemaleStudents + familyOthersStudents
        const totalEnterpreneurOptOutStudents =
          entrepreneurMaleStudents +
          entrepreneurFeMaleStudents +
          entrepreneurOthersStudents
        const totalHigherEducationOptOutStudents =
          higherEducationMaleStudents +
          higherEducationFemaleStudents +
          higherEducationOtherStudents
        const totalOthersOptOutStudents =
          othersMaleStudents + othersFemaleStudents + othersOtherStudents
        const optOutData = {
          totalFamilyStudents: formatStudentCount(
            totalFamilyReasonOptOutStudents,
            familyMaleStudents,
            familyFemaleStudents,
            familyOthersStudents
          ),
          totalEnterpreneurStudents: formatStudentCount(
            totalEnterpreneurOptOutStudents,
            entrepreneurMaleStudents,
            entrepreneurFeMaleStudents,
            entrepreneurOthersStudents
          ),
          totalHigherEducationStudents: formatStudentCount(
            totalHigherEducationOptOutStudents,
            higherEducationMaleStudents,
            higherEducationFemaleStudents,
            higherEducationOtherStudents
          ),
          totalOtherStudents: formatStudentCount(
            totalOthersOptOutStudents,
            othersMaleStudents,
            othersFemaleStudents,
            othersOtherStudents
          ),
        }
        const studentData = {
          placedStudents: formatStudentCount(
            totalPlacedStudents,
            placedMaleStudents,
            placedFemaleStudents,
            placedOtherStudents
          ),
          unplacedStudents: formatStudentCount(
            totalUnPlacedStudents,
            unplacedMaleStudents,
            unplacedFemaleStudents,
            unplacedOtherStudents
          ),
          optedOutStudents: formatStudentCount(
            totalOptedOutStudents,
            optedOutMaleStudents,
            optedOutFemaleStudents,
            optedOutOtherStudents
          ),
        }

        const totalStudents =
          Number(data?.totalPlacedCount) +
          Number(data?.totalUnplacedCount) +
          Number(data?.totalOptedOutCount)

        const percentageObj = {
          placedStudents: totalStudents
            ? ((data?.totalPlacedCount / totalStudents) * 100).toFixed(2)
            : '0',
          unplacedStudents: totalStudents
            ? ((data?.totalUnplacedCount / totalStudents) * 100).toFixed(2)
            : '0',
          optedOutStudents: totalStudents
            ? ((data?.totalOptedOutCount / totalStudents) * 100).toFixed(2)
            : '0',
        }

        const totalOptStudents =
          Number(totalFamilyReasonOptOutStudents) +
          Number(totalEnterpreneurOptOutStudents) +
          Number(totalHigherEducationOptOutStudents) +
          Number(totalOthersOptOutStudents)
        const optOutPercentageObj = {
          totalFamilyStudents: totalOptStudents
            ? (
                (totalFamilyReasonOptOutStudents / totalOptStudents) *
                100
              ).toFixed(2)
            : '0',
          totalEnterpreneurStudents: totalOptStudents
            ? (
                (totalEnterpreneurOptOutStudents / totalOptStudents) *
                100
              ).toFixed(2)
            : '0',
          totalHigherEducationStudents: totalOptStudents
            ? (
                (totalHigherEducationOptOutStudents / totalOptStudents) *
                100
              ).toFixed(2)
            : '0',
          totalOtherStudents: totalOptStudents
            ? ((totalOthersOptOutStudents / totalOptStudents) * 100).toFixed(2)
            : '0',
        }

        let wholeData = {
          ...data,
          list: list,
          totalStudents,
          percentageObj,
          totalCategoryStudentsObj: studentData,
          optOutPercentageObj,
          optOutData: optOutData,
        }
        if (compare) {
          dispatch(setCompareStudentPlacement(wholeData || {}))
        } else {
          dispatch(setStudentPlacement(wholeData || {}))
        }
      }
      return result
    } catch (err) {
      ErrorMessage(err?.message)
      dispatch(setStudentPlacement([]))
      return err
    }
  }
